import React from 'react';
import { ComponentWrapper } from 'app/gamma/src/components/ComponentWrapper';

import { HomeTestIds } from '@trello/webdriverio-tests';
import {
  Tab,
  TabButtonProps,
  TabIcon,
  TabLink,
  TabLinkProps,
  TabList,
  TabSection,
  TabText,
} from './tab';
import { TeamTabProps } from './team-tab';
import { TeamTabList } from './team-list'


import { forTemplate } from 'app/common/lib/util/i18n';
const l = forTemplate('home');

type HomeTabProps = TabLinkProps;

const HomeTab: React.FunctionComponent<HomeTabProps> = (props) => (
  <Tab>
    <TabLink data-test-id={HomeTestIds.HomeLink} {...props}>
      <TabIcon iconName="home" />
      <TabText>{l('home')}</TabText>
    </TabLink>
  </Tab>
);

type BoardsTabProps = TabLinkProps;

const BoardsTab: React.FunctionComponent<BoardsTabProps> = (props) => (
  <Tab>
    <TabLink {...props}>
      <TabIcon iconName="board" />
      <TabText>{l('boards')}</TabText>
    </TabLink>
  </Tab>
);

interface NavigationProps {
  homeTab: HomeTabProps;
  boardsTab: BoardsTabProps;
  teamTabs: TeamTabProps[];
  createTeamButton: TabButtonProps;
}

export const Navigation: React.FunctionComponent<NavigationProps> = ({
  homeTab,
  boardsTab,
  teamTabs,
  createTeamButton,
  ...props
}) => (
    <nav {...props}>
      <TabSection>
        <TabList>
          <BoardsTab {...boardsTab} />
          <HomeTab {...homeTab} />
        </TabList>
      </TabSection>
      <TabSection>
        <ComponentWrapper>
          <TeamTabList teamTabs={teamTabs} createTeamButton={createTeamButton} />
        </ComponentWrapper>
      </TabSection>
    </nav>
);
